import React from "react"
import Typography from "../../../../../ui/atoms/Typography"
import ExpandableMenu from "../../../../../ui/molecules/ExpandableMenu"
import {
  AlgoliaCheckboxCategory,
  AlgoliaCheckboxOption,
} from "../../controller/state/types"
import TagFilterOptions from "../TagFilterOptions"

const hasSelectedItems = (items: AlgoliaCheckboxOption[]) =>
  items.some((x) => x.selected)

interface Props {
  category: AlgoliaCheckboxCategory
}

export const TagSidebarFilter = ({ category }: Props) => {
  const [expanded, setExpanded] = React.useState(false)
  const [initialized, setInitialized] = React.useState(false)

  React.useEffect(() => {
    if (!initialized && category && category.options.length > 0) {
      setInitialized(true)
      setExpanded(hasSelectedItems(category.options))
    }
  }, [category])

  if (!category || category.options.filter((x) => !x.disabled).length <= 0) {
    return <></>
  }

  return (
    <ExpandableMenu
      label={
        <Typography
          variant="body1"
          weightValue={500 as any}
          textClassName="uppercase mb-2"
        >
          {category.label}
        </Typography>
      }
      expanded={expanded}
      onToggle={setExpanded}
      className="mt-1"
    >
      <TagFilterOptions
        category={category}
        maxScrollItems={10}
        minTextFilterItems={60}
      />
    </ExpandableMenu>
  )
}
